/**
 * Code calls
 */
export const getUnreadNotifications = 'notifications/getUnreadNotifications';
export const getNotifications = 'notifications/getNotifications';
export const setNotificationReadStatus =
  'notifications/setNotificationReadStatus';
export const setAllNotificationsReadStatus =
  'notifications/setAllNotificationsReadStatus';
